import React, { Fragment } from 'react'
import { ResponsiveBar } from '@nivo/bar'
import { line } from 'd3-shape'
import { metricOptionSet } from '../util'
import { ResponsiveLine } from '@nivo/line'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'

export const MetricHistoryChart = ({ barData, selectedRows, selectedMetric, selectedMetricType }) => {
  const { max, data } = barData
  const Line = ({ bars, xScale, yScale }) => {
    const filteredBars = bars.filter((bar) => bar.data.id === bars[0].data.id)
    const lineColor = '#c79c02'
    const lineGenerator = line()
      .defined((bar) => !!bar.data.data.comparisonValue)
      .x((bar) => xScale(bar.data.indexValue) + (bar.width * selectedRows.length) / 2)
      .y((bar) => yScale(bar.data.data.comparisonValue))

    return (
      <Fragment>
        <path
          d={lineGenerator(filteredBars)}
          fill='none'
          stroke={lineColor}
          style={{ pointerEvents: 'none', strokeWidth: '2px' }}
        />
        {filteredBars.map(
          (bar) =>
            bar.data.data.comparisonValue && (
              <circle
                key={bar.key}
                cx={xScale(bar.data.indexValue) + (bar.width * selectedRows.length) / 2}
                cy={yScale(bar.data.data.comparisonValue)}
                r={4}
                fill='white'
                stroke={lineColor}
                strokeWidth={3}
                style={{ pointerEvents: 'none' }}
              />
            )
        )}
      </Fragment>
    )
  }

  const tooltip = (bar) => {
    const rounded = bar?.formattedValue ? Math.round(parseFloat(bar?.formattedValue) * 1000) / 1000 : null
    return (
      <Horizontal verticalCenter className={'p-2'} style={{ backgroundColor: 'var(--bg-1)', opacity: 0.9 }}>
        <div style={{ backgroundColor: bar?.color, width: '15px', height: '15px' }}></div>

        <Texto category='p2' weight={600} className={'ml-2'}>
          {bar?.label}: {rounded}
        </Texto>
      </Horizontal>
    )
  }

  if (selectedRows.length !== 0) {
    return (
      <div style={{ height: 260 }}>
        <ResponsiveBar
          data={data}
          keys={selectedRows.map((row) => row.name)}
          indexBy='date'
          margin={{ top: 45, right: 10, bottom: 40, left: 60 }}
          theme={{ fontFamily: 'proxima-nova', textColor: 'var(--gray-700)', fontWeight: 'bold' }}
          groupMode='grouped'
          colors={({ id, data }) => String(data[`${id}Color`])}
          borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          axisTop={null}
          axisRight={null}
          enableLabel={false}
          isInteractive
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Week',
            legendPosition: 'middle',
            legendOffset: 32,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: metricOptionSet[selectedMetricType].find((item) => item.value === selectedMetric)?.display,
            legendPosition: 'middle',
            legendOffset: -40,
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor='white'
          legends={[
            {
              anchor: 'top-left',
              direction: 'row',
              justify: false,
              translateY: -33,
              itemsSpacing: 0,
              itemDirection: 'left-to-right',
              itemWidth: 160,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: 'circle',
              symbolBorderColor: 'rgba(0, 0, 0, .5)',
              effects: [
                {
                  on: 'hover',
                  style: {
                    itemBackground: 'rgba(0, 0, 0, .03)',
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
          tooltip={tooltip}
          role='application'
          barAriaLabel={(e) => {
            return e.id + ': ' + e.formattedValue + ' in country: ' + e.indexValue
          }}
          layers={['grid', 'axes', 'bars', Line, 'markers', 'legends']}
          maxValue={max + max * 0.2}
        />
      </div>
    )
  }
  return (
    <div style={{ height: 260 }}>
      <ResponsiveLine
        data={barData}
        margin={{
          top: 15,
          right: 50,
          bottom: 30,
          left: 80,
        }}
        theme={{ fontFamily: 'proxima-nova', textColor: 'var(--gray-700)', fontWeight: 'bold' }}
        pointSize={10}
        pointColor='#FFFFFF'
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        curve='natural'
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: metricOptionSet[selectedMetricType].find((item) => item.value === selectedMetric)?.display,
          legendPosition: 'middle',
          legendOffset: -60,
        }}
        animate
        enableArea
        isInteractive
      />
    </div>
  )
}
